import { useBack } from "../http";
import { NotificationDTO } from "../types/NotificationDTO";

export class NotificationService {
	constructor() {}
	axiosInstance = useBack();

	async getNotifications() {
		try {
			const response = await this.axiosInstance.get<NotificationDTO[]>('/notification');
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível obter as notificações`, error);
			return undefined;
		}
	}

	async markAsRead(notificationId: number) {
		try {
			const response = await this.axiosInstance.put(`/notification/${notificationId}/read`);
			return { ...response };
		} catch (error) {
			console.log(`Não foi possível marcar a notificação como lida`, error);
			return undefined;
		}
	}
}